import request from '@/utils/request'
import type {
  CreateExportTaskRequest,
  ExportEstimateRequest,
  ExportTaskListQuery,
} from '@/types/export'

const BASE_URL = '/organization/export/tasks'

export function estimateExport(data: ExportEstimateRequest): any {
  return request({
    url: '/organization/export/estimate',
    method: 'post',
    data,
  })
}

export function createExportTask(data: CreateExportTaskRequest): any {
  return request({
    url: BASE_URL,
    method: 'post',
    headers: { needOrgId: true },
    data,
    // 创建弹窗会就地展示错误，避免与全局错误提示重复。
    silentError: true,
  })
}

export function listExportTasks(params: ExportTaskListQuery, silentError = false): any {
  return request({
    url: BASE_URL,
    method: 'get',
    headers: { needOrgId: true },
    params,
    silentError,
  })
}

export function listGeneratingExportTasks(silentError = true): any {
  return listExportTasks(
    {
      pageNum: 1,
      pageSize: 100,
      status: 'GENERATING',
    },
    silentError,
  )
}

export function getExportPassword(taskId: string | number): any {
  return request({
    url: `${BASE_URL}/${taskId}/password`,
    method: 'get',
    headers: { needOrgId: true },
    silentError: true,
  })
}
